import Main from '@/views/administracion/configuracion/catalogos/etiquetas/Main.vue';
import Default from '@/views/administracion/configuracion/catalogos/etiquetas/Default.vue';

const auth = ['Catálogos:ver'];
const scopes = ['Catálogos:crear', 'Catálogos:editar', 'Catálogos:eliminar'];

const etiquetas = [
  {
    path: 'etiquetas',
    meta: {
      title: '',
      auth,
      scopes,
    },
    component: Main,
    children: [
      {
        name: 'catalogoEtiquetas',
        path: '/',
        meta: {
          title: 'Etiquetas',
          auth,
          scopes,
        },
        component: Default,
      },
    ],
  },
];

export default etiquetas;
